import config from './config'
import { TEMPLATE_TYPE_CODES } from '../consts'

const MIME_MAP = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
}
export const TemplateAPI = {
    create: (title, imgBlob, canvas, type) => {
        const formData = new FormData()
        formData.append('canvas', canvas)
        const ext = MIME_MAP[imgBlob.type]
        formData.append('preview_image', imgBlob, `newfile.${ext}`)
        formData.append('type', type)
        formData.append('title', title)
        const extra = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        return config.post('/api/library/templates/', formData, { ...extra })
    },
    update: (id, title, imgBlob, canvas, type) => {
        const formData = new FormData()
        formData.append('canvas', canvas)
        const ext = MIME_MAP[imgBlob.type]
        formData.append('preview_image', imgBlob, `newfile.${ext}`)
        formData.append('type', type)
        formData.append('title', title)
        const extra = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        return config.put(`/api/library/templates/${id}/`, formData, {
            ...extra,
        })
    },
    clone: (id) => {
        return config.post(`/api/library/template/clone/`, { template_id: id })
    },
    delete: (id) => {
        return config.delete(`/api/library/templates/${id}`)
    },
    getTextTemplates: () => {
        return config.get(
            `/api/library/templates/?type=${TEMPLATE_TYPE_CODES.TEXT}`
        )
    },
    getBlogTemplates: () => {
        return config.get(
            `/api/library/templates/?type=${TEMPLATE_TYPE_CODES.BLOG}`
        )
    },
    getListingTemplates: () => {
        return config.get(
            `/api/library/templates/?type=${TEMPLATE_TYPE_CODES.LISTING}`
        )
    },
    getOwned: () => {
        return config.get('/api/library/templates/?exclude_global=true')
    },
    get: (id) => {
        return config.get(`/api/library/templates/${id}/`)
    },
    getAll: () => {
        return config.get('/api/library/templates/')
    },
}
